import { useNavigate } from "react-router-dom";
import { Check, Snowflake } from "lucide-react";
import { PublicLayout } from "@/components/PublicLayout";
import { Button } from "@/components/ui/button";

const SERVICES = [
  { type: "Clim murale (split)", price: 60, desc: "Le plus courant. Nettoyage complet de l'unité intérieure et des filtres." },
  { type: "Console", price: 70, desc: "Unité au sol. Nettoyage approfondi et désinfection." },
  { type: "Cassette", price: 90, desc: "Encastrée au plafond. Démontage et nettoyage des grilles." },
  { type: "Gainable", price: 110, desc: "Système gainé. Vérification et nettoyage des bouches et du caisson." },
];

export default function Services() {
  const navigate = useNavigate();
  return (
    <PublicLayout>
      <section className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#1D9BF0]">Nos prestations</p>
        <h1 className="mt-2 text-4xl font-extrabold text-[#263871] sm:text-5xl">Tarifs transparents</h1>
        <p className="mt-4 max-w-xl text-lg text-slate-600">Prix HT par unité, hors déplacement. Le tarif final inclut une petite marge plateforme pour garantir le suivi qualité.</p>

        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {SERVICES.map((s) => (
            <div key={s.type} data-testid={`service-card-${s.price}`} className="flex flex-col rounded-2xl border border-slate-200 bg-white p-6 transition-shadow hover:shadow-lg">
              <div className="w-fit rounded-xl bg-[#E0F2FE] p-2.5"><Snowflake className="h-6 w-6 text-[#1D9BF0]" /></div>
              <h3 className="mt-4 text-lg font-bold text-[#263871]">{s.type}</h3>
              <p className="mt-2 flex-1 text-sm text-slate-600">{s.desc}</p>
              <p className="mt-4 text-3xl font-extrabold text-[#263871]">{s.price}€ <span className="text-sm font-medium text-slate-400">HT</span></p>
              <Button onClick={() => navigate("/inscription")} className="mt-4 w-full rounded-full bg-[#263871] hover:bg-[#35508F]">Réserver</Button>
            </div>
          ))}
        </div>

        <div className="mt-16 grid gap-8 rounded-3xl bg-white p-8 md:grid-cols-2 md:p-12">
          <div>
            <h2 className="text-2xl font-bold text-[#263871]">Pourquoi entretenir ?</h2>
            <ul className="mt-5 space-y-3">
              {["Air plus sain, sans bactéries ni allergènes", "Jusqu'à 25% d'économies d'énergie", "Durée de vie prolongée de votre matériel", "Obligation légale au-delà de 4kg de fluide"].map((t) => (
                <li key={t} className="flex gap-3 text-slate-700"><Check className="mt-0.5 h-5 w-5 shrink-0 text-emerald-500" />{t}</li>
              ))}
            </ul>
          </div>
          <div className="cl-gradient flex flex-col justify-center rounded-2xl p-8 text-white">
            <h3 className="text-xl font-bold">Besoin d'une nouvelle installation ?</h3>
            <p className="mt-2 text-sky-100">Nous trouvons un poseur certifié près de chez vous. Devis gratuit et sans engagement.</p>
            <Button onClick={() => navigate("/inscription")} className="mt-6 w-fit rounded-full bg-white text-[#263871] hover:bg-sky-50">Demander un devis</Button>
          </div>
        </div>
      </section>
    </PublicLayout>
  );
}
